import { useMemo } from 'react'
import { useThreatProfilesApiClient } from './client'

export const useThreatProfilesTokenClaims = () => {
  const api = useThreatProfilesApiClient()
  const token = api?.token

  return useMemo(() => {
    if (!token) { return }

    try {
      return JSON.parse(atob(token.split('.')[1]))
    } catch (e) {
      console.error(e)
    }
  }, [token])
}
